/*
 * @Author: Marte
 * @Date:   2017-11-14 17:02:27
 * @Last Modified by:   Marte
 * @Last Modified time: 2017-11-14 17:15:24
 */

'use strict';
angular.module('navTplModule', []).controller('navTplCtr', [
    '$q',
    '$timeout',
    '$element',
    '$state',
    '$location',
    '$scope',
    'trsHttpService',
    function($q, $timeout, $element, $state, $location, $scope, trsHttpService) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                pathType: $location
                    .path()
                    .split('/')
                    .pop(),
                naturaldisaster: true, // 安全事故权限
            };
            autoGo();
            // getPermission().then(function() {
            //     autoGo();
            // });
        }

        /**
         * [selectNav description] 选择模块
         * @param {string} [moduleName] [description] 模块名称
         * @return {[type]} [description]
         */
        $scope.selectNav = function(moduleName) {
            $scope.status.pathType = moduleName;
        };

        /**
         * [getPermission description] 获取权限
         * @return {[type]} [description]
         */
        function getPermission() {
            var deffer = $q.defer();
            var params = {
                typeid: 'widget',
                serviceid: 'tenantMgr',
                modelid: 'show',
            };
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                $scope.status.naturaldisaster = data.disaster == 1;
                deffer.resolve($scope.status.naturaldisaster);
            });

            return deffer.promise;
        }

        /**
         * [autoGo description] 自动跳转
         * @return {[type]} [description]
         */
        function autoGo() {
            if ($state.current.name.split('.').length === 5) {
                $timeout(function() {
                    $element.find('li')[0].click();
                }, 500);
            }
        }
    },
]);
